import React from 'react';

import FaqPage from '../components/FaqPage';

const FAQ = () => (
  <FaqPage
    lang="fr"
    title="FAQ | Full Stack open"
    seoDescription="Questions fréquemment posées"
  />
);

export default FAQ;
